// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2E_HN","checkboxCol":"Table_checkboxCol__1O50j","emailCol":"Table_emailCol__2sYUW","actionCol":"Table_actionCol__2s3Nv"};